/* eslint-disable */

$(document).ready(function(){
  $(".owl-carousel-gallery").owlCarousel({
      nav:true,
      items:1,
      dots:false,
      navText: ""
  });
});
